export default "__VITE_ASSET__EhvMiHkq__"